'use strict';
import EcsEmail from '@/components/ecs-email/EcsEmail';

const getEmailByInteractionId = state => interactionId => {
  const email = [...state.active, ...state.history].find(email => email.interactionId === interactionId);
  return email ? new EcsEmail(email) : null;
};

export default {
  getEmailByInteractionId
};
